import { useCallback, useEffect, useState } from 'react';
import { api } from '../lib/api';

export const useAdminSession = (shouldBootstrap = true) => {
  const [adminAccount, setAdminAccount] = useState(null);
  const [adminLoading, setAdminLoading] = useState(shouldBootstrap);

  const refreshAdminSession = useCallback(async () => {
    try {
      const { data } = await api.getAdminSession();
      const admin = data?.admin || null;
      setAdminAccount(admin);
      return { success: true, admin };
    } catch (error) {
      setAdminAccount(null);
      return { success: false, error: error?.response?.data?.detail || error.message };
    } finally {
      setAdminLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!shouldBootstrap) {
      setAdminLoading(false);
      setAdminAccount(null);
      return;
    }

    setAdminLoading(true);
    refreshAdminSession();
  }, [refreshAdminSession, shouldBootstrap]);

  const adminLogin = useCallback(async (payload) => {
    try {
      const { data } = await api.adminLogin(payload);
      const admin = data?.admin || null;
      setAdminAccount(admin);
      return { success: true, admin };
    } catch (error) {
      setAdminAccount(null);
      return { success: false, error: error?.response?.data?.detail || error.message };
    }
  }, []);

  const adminLogout = useCallback(async () => {
    try {
      await api.adminLogout();
      setAdminAccount(null);
      return { success: true };
    } catch (error) {
      return { success: false, error: error?.response?.data?.detail || error.message };
    }
  }, []);

  const updateAdminCredentials = useCallback(async (payload) => {
    try {
      const { data } = await api.updateAdminCredentials(payload);
      const admin = data?.admin || null;
      setAdminAccount(admin);
      return { success: true, admin };
    } catch (error) {
      return { success: false, error: error?.response?.data?.detail || error.message };
    }
  }, []);

  return {
    adminAccount,
    adminLoading,
    refreshAdminSession,
    adminLogin,
    adminLogout,
    updateAdminCredentials,
  };
};

export default useAdminSession;
